import React, { useState } from 'react';

import { Col, notification } from 'antd';

// components

import { FullScreenLoaderComponent } from 'baseComponents/FullScreenLoaderComponent';
import { TabsComponent } from 'baseComponents/TabsComponent';
import { PurchaseHistoryTab } from './components/PurchaseHistoryTab';
import { PurchaseCreditsTab } from './components/PurchaseCreditsTab';
import { ScreenWrapperComponent } from 'components/layouts/ScreenWrapperComponent';

// hooks
import { useGetCredits } from 'hooks/useGetCredits';

export const PurchaseCreditsScreen: React.FC = () => {
  const [, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  const creditsQuery = useGetCredits();
  

  return (
    <ScreenWrapperComponent>
      {contextHolder}
      <Col
        lg={{ pull: 6, push: 6, span: 12 }}
        md={{ pull: 1, push: 1, span: 22 }}
      >
        <TabsComponent
          items={[
            {
              label: 'Purchase Credits',
              key: 'purchase',
              children: (
                <PurchaseCreditsTab
                  creditsQuery={creditsQuery}
                  onLoadingChange={setLoading}
                />
              ),
            },
            {
              label: 'Purchase History',
              key: 'history',
              children: <PurchaseHistoryTab />,
            },
          ]}
        ></TabsComponent>
      </Col>
      <FullScreenLoaderComponent
        spinning={
          creditsQuery.isLoading || loading
        }
      />
    </ScreenWrapperComponent>
  );
};
